import React from 'react';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { SettingDisplay } from 'lib/SettingDisplay';

export const LightspeedKSeriesSettingsEdit: React.FC<IPointOfSaleSettingsProps> = ({ locationId }) => (
    <>
        {locationId === undefined && (
            <SettingDisplay label="Host">
                <TextFormField name="lightspeedKSeriesHost" />
            </SettingDisplay>
        )}

        {locationId !== undefined && (
            <>
                <SettingDisplay label="Business Location ID">
                    <TextFormField name="lightspeedKSeriesLocationId" />
                </SettingDisplay>
                <SettingDisplay label="Payment Method Code">
                    <TextFormField name="lightspeedKSeriesPaymentMethodCode" />
                </SettingDisplay>
            </>
        )}
    </>
);
